import React from 'react'
import FontAwesome from 'react-fontawesome'
import _ from 'lodash'

export default class Loading extends React.Component {
	render() {
		const objIcon = {
			className: 'loading',
			name: 'circle-notch',
			pulse: true,
			spin: true
		}

		if (_.has(this.props, 'size')) {
			objIcon.size = this.props.size
		}

		return (_.has(this.props, 'text'))
			? (
				<div className="text-center" style={this.props.style}>
					{ this.props.text}
					{' '}
					<FontAwesome
						{...objIcon}
					/>
				</div>
			)
			: <FontAwesome {...objIcon} />
	}
}


Loading.defaultProps = {
	style: {}
}



// WEBPACK FOOTER //
// ./src/modules/_shared/loading.jsx